import * as React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { formatoDecimal, validateNumber } from '../../../../utilities/formatoNumeros';
import { toast } from 'react-toastify';

export default class NovedadesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liquidaciones: props.liquidaciones,
      seleccionarTodo: false,
      nuevoImporte: null
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.liquidaciones !== this.props.liquidaciones) {
      this.setState({ liquidaciones: this.props.liquidaciones })
    }
  }

  handleChangeCheckbox = (id) => {
    this.setState((prevState) => {
      const liquidaciones = prevState.liquidaciones.map((liquidacion) => {
        if (liquidacion.idNovedad === id) {
          return {
            ...liquidacion,
            checked: !liquidacion.checked
          };
        }
        return liquidacion;
      });
      return { liquidaciones };
    });
  };

  handleSelectAllCheckbox(seleccionarTodo) {
    this.setState((prevState) => {
      const liquidaciones = prevState.liquidaciones.map((liquidacion) => ({
        ...liquidacion,
        checked: seleccionarTodo
      }));
      return { liquidaciones };
    });
    this.setState({ seleccionarTodo: seleccionarTodo });
  };

  onChangeImporte = (event) => {

    const { value } = event.target;

    if (validateNumber(value)) {
      this.setState({ nuevoImporte: value });
    };
  }

  confirmarNovedades() {

    let idLiquidaciones = this.state.liquidaciones
                          .filter(x => x.checked === true && x.idEstado !== 3)
                          .map(x => x.idNovedad)
    ;

    if (idLiquidaciones.length === 0) {
      toast.warn("Selecione alguna novedad");
      return;
    }

    this.setState({ seleccionarTodo: false });
    this.props.confirmarNovedadesFunction(idLiquidaciones);
  };

  editarNovedad(idNovedad) {

    if (this.state.nuevoImporte === null) {
      toast.warn("Ingrese un importe válido");
      return;
    };

    this.props.editarNovedadFunction(idNovedad, parseFloat(this.state.nuevoImporte));
  };


  render = () => {

    return (
      <div className="card shadow-sm border-0">
        <div className="card-body p-0">
          <div className="row align-items-center gap-2 gap-md-0 px-3 py-3 bg-light border-bottom rounded-top">
            <div className="col-auto">
              <input
                type="checkbox"
                className="form-check-input big-checkbox me-2 align-middle"
                checked={this.state.seleccionarTodo}
                onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
              />
              <span className="fw-medium">Seleccionar todo</span>
            </div>
            <div className="col-auto">
              <button
                title="Confirmar Novedades"
                className="btn btn-sm background-rojo-megatone text-white"
                onClick={() => this.confirmarNovedades()}
              >
                Marcar confirmadas
              </button>
            </div>
            {this.props.onOrdenFechaChange && (
              <div className="col-auto ms-md-auto">
                <label className="me-2 small text-muted mb-0">Orden por fecha:</label>
                <select
                  className="form-select form-select-sm d-inline-block w-auto"
                  value={this.props.ordenFecha ?? "desc"}
                  onChange={(e) => this.props.onOrdenFechaChange(e.target.value)}
                >
                  <option value="desc">Más recientes primero</option>
                  <option value="asc">Más antiguas primero</option>
                </select>
              </div>
            )}
          </div>

          <div className="table-responsive">
            <table className="table table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th className="col-auto border-0"></th>
                  <th className="col-2 border-0">Fecha</th>
                  <th className="col-2 border-0">Seller</th>
                  <th className="col-1 border-0">Orden Ref.</th>
                  <th className="col-3 border-0">Concepto</th>
                  <th className="col-auto border-0">Acción</th>
                  <th className="col-2 border-0">Importe</th>
                  <th className="col-1 text-nowrap border-0">% Penalidad</th>
                  <th className="col-1 border-0">Estado</th>
                  <th className="col-2 border-0">Editar</th>
                </tr>
              </thead>
              <tbody>
              {
                this.state.liquidaciones.map((liquidacion, i) => {
                  return (
                    <tr key={i} className="hover-background-color">
                      <td>
                        <input 
                          type="checkbox" 
                          className="big-checkbox ml-2"
                          hidden={liquidacion.idEstado === 3}
                          checked={liquidacion.checked || false}
                          onChange={() => this.handleChangeCheckbox(liquidacion.idNovedad)}
                        />
                      </td>
                      <td><small>{liquidacion.fechaNovedad ? liquidacion.fechaNovedad : "No disponible"}</small></td>
                      <td><small>{liquidacion.sellerRazonSocial}</small></td>
                      <td><small>{liquidacion.ordenDeReferencia}</small></td>
                      <td>
                        <small>
                          {liquidacion.detalleTipoNovedad}
                          <br/> 
                          {liquidacion.comentarios == "" ? "-" : liquidacion.comentarios}
                        </small>
                      </td>
                      <td><small>{liquidacion.detalleSubTipoNovedad}</small></td>
                      <td>
                        <small>${formatoDecimal(liquidacion.importe)}</small>
                      </td>
                      <td className="text-nowrap align-middle">
                        <small className="d-inline">
                          {(() => {
                            const valor = liquidacion.porcentajePenalidad ?? liquidacion.porcentaje ?? liquidacion.PorcentajePenalidad ?? liquidacion.Porcentaje;
                            if (valor == null || valor === "") return "—";
                            const num = Number(valor);
                            return Number.isFinite(num) ? `${num}%` : "—";
                          })()}
                        </small>
                      </td>
                      <td><small>{liquidacion.detalleEstadoNovedad}</small></td>
                      <td>
                      {
                        liquidacion.idEstado !== 3 ?
                        <div key={i}>
  
                          <OverlayTrigger
                            key={`overlay-edit-${i}`}
                            trigger="click"
                            rootClose={true}
                            placement={"top"}
                            overlay={
                              <Popover id={`popover-edit-${i}`}>
                                <Popover.Header className="text-center" as="h3">¿Actualizar Importe?</Popover.Header>
                                <Popover.Body className="row justify-content-center align-items-center">

                                  <label className="col-6">Nuevo Importe:</label>

                                  <div className="col-6">
                                    <input 
                                      type="text" 
                                      className="form-control" 
                                      value={this.state.nuevoImporte}
                                      onChange={this.onChangeImporte} 
                                      maxLength="10"
                                    />
                                  </div>

                                  <div className="mt-3 col-auto">
                                    <button 
                                      onClick={() => this.editarNovedad(liquidacion.idNovedad)}
                                      className="btn btn-sm background-rojo-megatone"
                                      disabled={
                                        this.state.nuevoImporte === liquidacion.importe || 
                                        this.state.nuevoImporte === ""
                                      }
                                    >
                                      Actualizar
                                    </button>
                                  </div>
                                </Popover.Body>
                              </Popover>
                            }
                          >
                            <button 
                              type="button" 
                              title="Actualizar Importe" 
                              className="btn"
                              onClick={() => this.setState({ nuevoImporte: liquidacion.importe })}
                            >
                              <i className="fa fa-clipboard" aria-hidden="true"/>
                            </button>
                          </OverlayTrigger>
  
                          <OverlayTrigger
                            key={`overlay-delete-${i}`}
                            trigger="click"
                            rootClose={true}
                            placement={"top"}
                            overlay={
                              <Popover id={`popover-delete-${i}`}>
                                <Popover.Header as="h3">¿Eliminar Novedad?</Popover.Header>
                                <Popover.Body className="row justify-content-center">
                                  <button 
                                    className="btn btn-sm background-rojo-megatone col-auto"
                                    onClick={() => this.props.eliminarNovedadFunction(liquidacion.idNovedad)}
                                  >
                                    Eliminar
                                  </button>
                                </Popover.Body>
                              </Popover>
                            }
                          >
                            <button 
                              title="Eliminar" 
                              type="button" 
                              className="btn color-rojo-megatone"
                            >
                              <i className="fa fa-trash" aria-hidden="true"/>
                            </button>
                          </OverlayTrigger>
                        </div> : ""
                      }
                      </td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
